import { ReactFragment } from "react";

import { NextImage } from "@/lib/ghost";

interface HeaderBackgroundProps {
  srcImg: string | NextImage;
  children: ReactFragment;
}

export const HeaderBackground = ({
  srcImg,
  children,
}: HeaderBackgroundProps) => (
  <>
    {srcImg ? (
      <div
        className="outer site-header-background responsive-header-img"
        style={{ backgroundImage: `url(${srcImg})` }}
      >
        {children}
      </div>
    ) : (
      <div className="outer site-header-background no-image">{children}</div>
    )}
  </>
);
